import React from 'react';
import useTranslation from "../../virtual_congress/effects/use_translation";

export const ThankYou = () => {
  const translation = useTranslation()

  return (
    <div className={"selfie-thank-you-container"}>
      {translation("selfie_upload.thank_you", {}, "Thank you!")}
    </div>
  )
}